import { ReactiveControllerHost } from 'lit';
import { isEqual } from 'lodash-es';
import { ReduxController as BaseReduxController } from '../../../common/redux/controllers/redux-controller';
import { store, TpcRootState } from '../store';

export class ReduxController extends BaseReduxController<TpcRootState> {
    constructor(host: ReactiveControllerHost) {
        super(host, store);
    }

    stateChanged(store: TpcRootState): void {
        if (!isEqual(store, this.store)) {
            this.updateState(store);
            this.host.requestUpdate();
        }
    }
}
